module.exports = __webpack_public_path__ + "8d13b2be9109da63225b4cab00d33af8.png";